import React from 'react';
import PropTypes from 'prop-types';
import css from './Input.css';
import Icon from 'SF/MaterialIcon';

const Input = React.forwardRef((props, ref) => {
  const { hasError, errorMessage, label, hint, ...rest } = props;
  const addErrorStyle = attr => ({[attr]: hasError || errorMessage ? "#C70000" : null});
  return (
    <div className={css['input-group']}>
      <input {...rest} style={addErrorStyle('borderBottomColor')} ref={ref} />
      <label style={addErrorStyle('color')} htmlFor={props.id}>{label}</label>
      <div className={css['hint']} style={addErrorStyle('color')}>
        {errorMessage && <Icon aria-hidden="true" icon="error"/>}
        {(errorMessage || hint) && <div>{errorMessage || hint}</div>}
      </div>
    </div>
  )
});

Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  hint: PropTypes.string,
  hasError: PropTypes.bool,
}

export default Input;
